// import { Link } from 'react-router-dom';

import { useHistory } from 'react-router-dom';

const OnBoardingCard = ({ image, role, route, variant, signUpRole, setFormFields }) => {
  const history = useHistory();
  return (
    <div
      className={`${variant === 'disabled' ? 'bg-gray-100' : 'bg-white'} py-9 px-5 
      mt-4 md:mt-6 lg:mt-8
       w-full rounded-xl flex flex-col items-center hover:shadow-xl gap-3 `}
      style={{ minHeight: '196px' }}
    >
      <div className="flex flex-col justify-center items-center mb-1 ">
        <img
          src={image}
          className={`${variant === 'disabled' ? ' grayscale' : ''} mb-1 h-12 w-12`}
          style={{ filter: variant === 'disabled' ? 'grayscale(90%)' : '' }}
          alt={''}
        />
        <h3>{role}</h3>
      </div>

      {variant !== 'disabled' ? (
        <button
          // to={`/signup?role=${signUpRole}`}
          onClick={() => {
            if (route) {
              history.push(route);
            }
            setFormFields &&
              setFormFields((data) => {
                return { ...data, role: signUpRole };
              });
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-8 w-8 text-blue-kheloBlue hover:bg-blue-kheloBlue rounded-full cursor-pointer hover:text-white border-1 border-blue-kheloBlue transition-all ease-in-out duration-200"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2}
          >
            <path strokeLinecap="round" strokeLinejoin="round" d="M13 7l5 5m0 0l-5 5m5-5H6" />
          </svg>
        </button>
      ) : null}
    </div>
  );
};

export default OnBoardingCard;
